import { FieldProps } from "@fluentui/react-components";
import { ZodIssue } from 'zod'

import { FormLens, LocalizedGenericErrorCode } from "@tdp/common/form";

type FormFieldProps = Pick<FieldProps, 'validationState' | 'validationMessage'>;

function defaultErrorMapper(issues: ZodIssue[]) {
  if (issues.length > 0) {
    return <LocalizedGenericErrorCode issue={issues[0]} />
  }
}

export interface IUseFormFieldOptions {
  errorMapper?: (issues: ZodIssue[]) => FormFieldProps['validationMessage'];
}

/**
 * Get the props for a fluentui 'Field' component for a specified form lens.
 * @param lens the form lens.
 * @param options additional options for customizing the validation errors.
 * @returns props for the <Field> component.
 */
export function useFormFieldProps(lens: FormLens<unknown>, options: IUseFormFieldOptions): FormFieldProps {
  const {
    errorMapper = defaultErrorMapper,
  } = options;
  return {
    validationState: lens.validationErrors.length > 0 ? 'error' : 'none',
    validationMessage: errorMapper(lens.validationErrors)
  }
}
